<template>
	<v-dialog v-model="dialog" scrollable width="800px" persistent>
		<v-card>
			<v-card-title>
				Advanced search
				<v-divider />
				<v-btn-toggle
					v-model="localFilter.Operator"
					tile
					color="primary"
					class="d-flex"
					group
					mandatory
				>
					<span class="align-self-center">Operation:</span>
					<v-btn class="flex-grow-1" :value="1">And</v-btn>
					<v-btn class="flex-grow-1" :value="2">Or</v-btn>
				</v-btn-toggle>
				<v-divider />
			</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<div
						v-for="(filterItem, index) in localFilter.Filters"
						:key="index"
					>
						<filter-component
							class="d-flex mb-4"
							v-if="filterItem && !filterItem.IsDeleted"
							:columns="columns"
							:filter="filterItem"
							:index="index"
							@onRemoveFilter="removeFilter"
							@filterChanged="onFilterChanged"
						/>
					</div>
				</v-form>
				<v-btn color="primary" outlined @click="addFilter">
					<v-icon>mdi-plus</v-icon>
					Add filter
				</v-btn>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-btn color="error" @click="clearFilters">Clear</v-btn>
				<v-spacer />

				<v-btn text outlined @click="closeFilters">Cancel</v-btn>
				<v-btn color="primary" @click="applyFilters">Apply</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import FilterComponent from './FilterComponent.vue';

export default {
	name: 'FiltersDialog',
	props: {
		columns: Array,
		filter: Object,
		dialog: Boolean,
	},
	components: { FilterComponent },
	computed: {
		filtersCount() {
			if (this.localFilter) return this.localFilter.Filters.length;
			return 0;
		},
	},
	data() {
		return {
			localFilter: { Operator: 1, Filters: [] },
			oldFilterValues: null,
		};
	},
	watch: {
		filter(val) {
			if (val) this.localFilter = val;
		},
	},
	mounted() {
		if (this.filter) {
			this.localFilter = this.filter;
			this.oldFilterValues = JSON.parse(JSON.stringify(this.filter));
		}
	},
	methods: {
		clearFilters() {
			this.localFilter = {
				Operator: 1,
				Filters: [],
			};
			this.$emit('filterChanged', this.localFilter);
		},
		closeFilters() {
			this.$emit('filterChanged', this.oldFilterValues);
		},
		validateFilters() {
			let result = true;
			if (this.localFilter.Filters) {
				this.localFilter.Filters.forEach((x) => {
					if (x.FieldId == '' && x.Operator == null) result = false;
				});
			}
			return result;
		},
		applyFilters() {
			if (this.$refs.form.validate()) {
				let notDeletedFilter = this.localFilter.Filters.filter(
					(x) => !x.IsDeleted
				);
				this.localFilter.Filters = notDeletedFilter;
				this.$emit('filterChanged', this.localFilter);
			}
		},
		addFilter() {
			this.localFilter.Filters.push({
				FieldId: '',
				Operator: null,
				IsDeleted: false,
				Value: '',
			});
		},
		removeFilter(index) {
			let filter = Object.assign({}, this.localFilter);
			filter.Filters[index].IsDeleted = true;
			this.localFilter = filter;
		},
		onFilterChanged(filter, index) {
			this.localFilter.Filters.splice(index, 1, filter);
		},
	},
};
</script>
